// extracted by mini-css-extract-plugin
module.exports = {"DetailsBody":"styles_DetailsBody__1Op5z","DetailsVideoWrapper":"styles_DetailsVideoWrapper__29XoA"};